import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.splide.splide-sec11')) {
    const options = {
      fixedWidth: "290px",
      type: "loop",
      gap: '0',
      arrows: false,
      drag: false,
      flickPower: 100,
      pagination: false,
      autoScroll: {
        speed: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        768: {
          fixedWidth: "33.333333%",
          gap: '0',
        },
      },
    };
    const splide = new Splide(".splide.splide-sec11", options);
    splide.mount({ AutoScroll });
  }
});
